var Death = require('./workAccidentDeath');
var Disability = require('./workAccidentDisability');
var Case = require('./cortCase');
module.exports = san.defineComponent({
    template: require('../views/workAccident.html'),
    initData: function () {
        return {
            showFlag:1,
            backFlag:false,
            listType:1,
            cortData:''
        };
    },
    components: {
        'death': Death,
        'disability': Disability,
        'case': Case
    },
    created: function() {
        this.saveInfo(this.data.get('listType'),"SEE");
    },
    switchType: function(t){
        this.data.set('showFlag', t);
        this.data.set('backFlag', false);
        this.saveInfo(t,"SEE")
    },
    saveInfo: function(t,c){
        var visitModelDetailId,visitModelDetailName;
        if(t==2){
            visitModelDetailId = 'COMPENSATION_CALCULATE-WORK_DIE';
            visitModelDetailName = '赔偿计算-工伤死亡';
        }else{
            visitModelDetailId = 'COMPENSATION_CALCULATE-WORK_HARM';
            visitModelDetailName = '赔偿计算-工伤伤残';
        }
        window.NewLog._saveLog(visitModelDetailId,visitModelDetailName,"","",c);
    },
    goBack: function(){
        var flag=this.data.get('listType');
        var me=this;
        san.nextTick(function () {
            if(flag==1){
                me.data.set('backFlag',false);
                me.ref('Accident').back(flag);
            }else{
                me.data.set('listType',1);
                me.ref('Accident').back(flag);
            }
        })
    },
    messages: {
        goScroll: function(top){
            window.ToScroll._scroll($('.traffic-content')[0],top.value);
            this.saveInfo(this.data.get("showFlag"),"CALCULATION");
        },
        goTo: function(top){
            $('.traffic-content')[0].scrollTop= $('.traffic-content')[0].scrollTop-top.value;
            this.data.set('backFlag', true);
            this.saveInfo(this.data.get("showFlag"),"CREATE_CONSULT_WORD");
        },
        createCort: function(data){
            this.data.set('listType', 2);
            this.data.set('backFlag', false);
            var me=this;
            san.nextTick(function () {
                me.ref('Accident2').getCort(data.value);
            });
        },
        goBack: function(){
            var flag=this.data.get('listType');
            if(flag==1){
                this.data.set('backFlag',false);
            }else{
                this.data.set('listType',1);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/workAccident.js
// module id = 359
// module chunks = 1